import { Component, Input } from '@angular/core';

@Component({
	selector: 'connecting-spinner',
	templateUrl: './ConnectingSpinner.Component.html'
})
export class ConnectingSpinnerComponent {
	@Input() public destination: string;
}
